<template>
  <div id="navCard" v-show="isShowCard">
    <div class="mask" @click="hideCard"></div>
    <div class="navMain">
      <div class="navMain-header">
        <div class="h-row">
          <div class="h-row-icon icon-b"></div>
          <div class="h-row-input">我的位置</div>
        </div>
        <div class="h-row">
          <div class="h-row-icon icon-r"></div>
          <div class="h-row-input"
            :class="currentName != '请选择导航点' ? '':'text-g'">
            {{ currentName }}
          </div>
        </div>
      </div>
      <div class="place-list">
        <div class="place-item" v-for="(item, index) in navData.data" :key="index">
          <div class="place-sign">
            <i></i>
            {{ item.mark ? '终点' : '途径点' }}
          </div>
          <div class="place-name">{{ formatAddress(item.address) }}</div>
          <div class="place-btn" @click="handleNav(item)">
            <a :href="setNavLink(item)">
              <i></i>导航
            </a>
          </div>
        </div>
      </div>
      <div class="navMain-text">注意：需要手机已安装百度地图app！</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["navData"],
  data() {
    return {
      isShowCard: false,
      currentName: "请选择导航点"
    }
  },
  mounted() {
    console.log(this.navData.data)
  },
  methods: {
    showCard() {
      this.isShowCard = true;
    },
    hideCard() {
      this.isShowCard = false;
    },
    formatAddress(text) {
      if (text == '没有找到地址信息，请手动输入。') {
        return '没有找到地址信息...';
      } else {
        return text;
      }
    },
    handleNav(item) {
      this.currentName = item.address;
      console.log(item.point)
    },
    setNavLink(item) {
      return `baidumap://map/navi?location=${item.point.lat},${item.point.lng}&coord_type=bd09ll&type=BLK&src=ios.baidu.openAPIdemo`
    }
  }
}
</script>

<style scoped lang="less">
@import "../assets/less/NavigationCard.less";
</style>